import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography } from '@mui/material';

import { map, find, isEqual, isEmpty } from 'lodash';

import MapContainerViewMap from '../../containers/MapContainerViewMap/index';
import * as mapOps from '../../../api/Maps/map-operations';

const MapChronologyCollage = ({ maps, listChronologyMaps, deployEnv, layers }) => {
  const [indexMap, setIndexMap] = React.useState(0);
  const [isLoadedColMap, setIsLoadedColMap] = React.useState(false);

  const mapChronologyView = map(listChronologyMaps, mapElement => {
    const mapIdChornology = mapElement.mapId;
    const mapObject = find(maps, mapItem => isEqual(mapOps.getId(mapItem), mapIdChornology));
    return mapObject;
  });

  const handleMapLoaded = isLoaded => {
    if (isLoaded) {
      setIndexMap(indexMap + 1);
    }
    if (indexMap === 3 && isLoaded) setIsLoadedColMap(true);
  };

  const columnMapsCollage = mapsColumn => {
    const colsToRender = map(mapsColumn, mapCol => {
      const baseMap = mapOps.getLayerObjectsArray(mapCol, layers, false);
      const layerMap = mapOps.getLayerObjectsArray(mapCol, layers);
      const dateCreatedMap = mapCol.createdAt;
      const dateText = dateCreatedMap.substring(0, dateCreatedMap.lastIndexOf('T'));
      const hourText = dateCreatedMap.substring(
        dateCreatedMap.lastIndexOf('T') + 1,
        dateCreatedMap.lastIndexOf('Z')
      );
      return (
        <Stack key={mapOps.getId(mapCol)} direction="column" width="100%" marginRight="2%">
          <Typography key={mapOps.getId(mapCol)}>
            {mapOps.getName(mapCol)} {dateText} - {hourText}
          </Typography>
          <MapContainerViewMap
            baseMaps={baseMap}
            deployEnv={deployEnv}
            layers={layerMap}
            map={mapCol}
            externalBoton
            leafletMapId={`imaps-multi-chronology-${mapOps.getId(mapCol)}`}
            handleMapLoaded={handleMapLoaded}
            height="50vh"
            width="400px"
          />
        </Stack>
      );
    });
    return colsToRender;
  };

  return (
    <>
      <Stack
        marginRight="1%"
        marginLeft="1%"
        marginTop="5%"
        direction="row"
        display="flex"
        justifyContent="space-around"
        width="100%"
      >
        {!isEmpty(mapChronologyView) && columnMapsCollage(mapChronologyView.slice(0, 4))}
      </Stack>
      {isLoadedColMap && (
        <Stack
          marginRight="1%"
          marginLeft="1%"
          marginTop="1%"
          direction="row"
          display="flex"
          justifyContent="space-around"
          width="100%"
        >
          {!isEmpty(mapChronologyView) && columnMapsCollage(mapChronologyView.slice(4, 8))}
        </Stack>
      )}
    </>
  );
};

MapChronologyCollage.defaultProps = {
  deployEnv: 'gmv'
};

MapChronologyCollage.propTypes = {
  maps: PropTypes.array.isRequired,
  layers: PropTypes.array.isRequired,
  listChronologyMaps: PropTypes.array.isRequired,
  deployEnv: PropTypes.string
};

export default MapChronologyCollage;
